import React, { useContext } from "react";
import Row from "@amzn/meridian/row";
import AuditContext from "../../store/audit-store";
import RosterStatsRow from "./RosterStatsRow";
import { INVALID_STATUS } from "../../constants";
import { resolveShiftStatus, statusColorClasses, INVALID_STATUS_CLASSES } from "./shiftStatus";

/**
 * Standalone shift-status badge (status text + start/end times, color-coded). Reads the selected
 * plan group's status from AuditContext — the same single source of truth AuditStatsRow uses — so
 * the CH Overall tab surfaces the shift status (e.g. Overridden) that the per-segment and legacy
 * views already show. Renders the red "Invalid" badge when no status resolves.
 */
export default function ShiftStatusBadge() {
  const { planGroups, selectedPlanGroupId, rosterIdList, currentRosterId } = useContext(AuditContext);

  const resolved = resolveShiftStatus(planGroups, selectedPlanGroupId, rosterIdList, currentRosterId);
  const hasStatus = !!resolved?.status;
  const status = hasStatus ? resolved!.status! : INVALID_STATUS;
  const { textClass } = hasStatus ? statusColorClasses(status) : INVALID_STATUS_CLASSES;

  return (
    <Row alignmentHorizontal="center">
      <RosterStatsRow
        status={status}
        startTime={hasStatus ? resolved!.startTime ?? "" : ""}
        endTime={hasStatus ? resolved!.endTime ?? "" : ""}
        textClass={textClass}
      />
    </Row>
  );
}
